import * as widget from '@shared/enums/widget.enums';

export const widgets = {
  paperless: {
    title: widget.Title.Paperless,
    description: widget.Description.Paperless,
    icon: {
      name: widget.WidgetIcon.Paperless,
      color: widget.IconColor.Green,
    },
    image: widget.Image.Paperless,
    links: [
      {
        label: widget.LinkLabel.Paperless,
        route: widget.LinkRoute.Paperless,
      },
    ],
  },
  none: {
    title: '',
    description: '',
  },
  facts: {
    title: widget.Title.Facts,
    description: widget.Description.Facts,
    icon: {
      name: widget.WidgetIcon.Facts,
      color: widget.IconColor.Green,
    },
    image: widget.Image.Facts,
  },
  form1099Ready: {
    title: widget.Title.Form1099Ready,
    description: widget.Description.Form1099Ready,
    icon: {
      name: widget.WidgetIcon.Form1099Ready,
      color: widget.IconColor.Blue,
    },
    image: widget.Image.TaxFormsNotice,
    isTaxWidget: true,
    links: [
      {
        label: widget.LinkLabel.Form1099Ready,
        route: widget.LinkRoute.Form1099Ready,
      },
    ],
  },
  form1099Soon: {
    title: widget.Title.Form1099Soon,
    description: widget.Description.Form1099Soon,
    icon: {
      name: widget.WidgetIcon.Form1099Soon,
      color: widget.IconColor.Blue,
    },
    image: widget.Image.TaxFormsNotice,
    isTaxWidget: true,
    links: [
      {
        label: widget.LinkLabel.Form1099Soon,
        route: widget.LinkRoute.Form1099Soon,
      },
    ],
  },
  form1099When: {
    title: widget.Title.Form1099When,
    description: widget.Description.Form1099When,
    icon: {
      name: widget.WidgetIcon.Form1099When,
      color: widget.IconColor.Blue,
    },
    isTaxWidget: true,
  },
  formW2Ready: {
    title: widget.Title.FormW2Ready,
    description: widget.Description.FormW2Ready,
    icon: {
      name: widget.WidgetIcon.FormW2Ready,
      color: widget.IconColor.Blue,
    },
    image: widget.Image.TaxFormsNotice,
    isTaxWidget: true,
    links: [
      {
        label: widget.LinkLabel.FormW2Ready,
        route: widget.LinkRoute.FormW2Ready,
      },
    ],
  },
  formW2Soon: {
    title: widget.Title.FormW2Soon,
    description: widget.Description.FormW2Soon,
    icon: {
      name: widget.WidgetIcon.FormW2Soon,
      color: widget.IconColor.Blue,
    },
    image: widget.Image.TaxFormsNotice,
    isTaxWidget: true,
    links: [
      {
        label: widget.LinkLabel.FormW2Soon,
        route: widget.LinkRoute.FormW2Soon,
      },
    ],
  },
  formW2When: {
    title: widget.Title.FormW2When,
    description: widget.Description.FormW2When,
    icon: {
      name: widget.WidgetIcon.FormW2When,
      color: widget.IconColor.Blue,
    },
    isTaxWidget: true,
  },
  timeOff: {
    title: widget.Title.TimeOff,
    description: widget.Description.TimeOff,
    icon: {
      name: widget.WidgetIcon.TimeOff,
      color: widget.IconColor.Green,
    },
    image: widget.Image.TimeOff,
  },
  tipsForm: {
    title: widget.Title.TipsForm,
    description: widget.Description.TipsForm,
    links: [
      {
        label: widget.LinkLabel.TipForm4070,
        pdfLink: widget.TipsForm.F4070,
      },
      {
        label: widget.LinkLabel.TipForm4070A,
        pdfLink: widget.TipsForm.F4070a,
      },
    ],
  },
};
